import {Capacitor} from '@capacitor/core';
import {environment} from '../../../environments/environment';

/** Native shells have their own configuration; responsive web remains web. */
export function appChannelCode(): string {
  return typeof window !== 'undefined' && Capacitor.isNativePlatform()
    ? 'mobile'
    : environment.channelCode;
}
